import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import { Input, type InputProps } from '@/ui';

/** Shown/hidden password with a toggle in the box. */
export function PasswordInput(props: InputProps) {
  const { t } = useTranslation('auth');
  const [shown, setShown] = useState(false);
  return (
    <Input
      {...props}
      type={shown ? 'text' : 'password'}
      suffix={
        <button
          type="button"
          aria-label={shown ? t('hidePassword') : t('showPassword')}
          onClick={() => setShown((s) => !s)}
          className="m-0 flex cursor-pointer border-0 bg-transparent p-0 text-ink-faint hover:text-ink"
        >
          {shown ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
        </button>
      }
    />
  );
}
